
import { Component, Vue, Prop } from "vue-property-decorator";
import MainHeader from "@/components/main-header.vue";
import {
  GetDictionary,
  GetAllSource,
  PostAddPatient,
  PatchEditPatient,
  GetPatientDetail,
  GetPatientList,
} from "@/request/common";
const cityData = require("@/assets/pca-code.json");
import Agree from "../components/agree.vue";
import SelectDuoxuan from "../components/select-duoxuan.vue";
import { GetKey } from "@/utils/base";
@Component({
  components: {
    MainHeader,
    Agree,
    SelectDuoxuan,
  },
})
export default class Name extends Vue {
  private patient: any = {
    source: {},
    address: [],
    phone_number: null,
  };
  private patientList: any = [];
  private uidTypes: any = [];
  private sources: any = [];
  private genders: any = [];
  private cityOption: any;
  private showAgree: any = false;
  private ifShowSelect: any = false;
  private selectTitle: any = "";
  private selectVal: any = [];
  private disabledStartDate: any = this.endDate();
  private bodyTypes: any = ["无", '虚胖', '腹围大', '臀围大腿粗', '肌肉强壮'];
  private get systemInfo() {
    return this.$store.state.systemInfo;
  }
  private endDate() {
    const self = this;
    return {
      disabledDate(time: any) {
        return time.getTime() > Date.now();
      },
    };
  }
  private enrollFinger() {
    console.log('录入指纹');
    if (this.patient.name) {
      window.electronMyAPI.enrollFinger(this.patient.name);
    }
  }
  private nameChange(e: any) {
    // 如果患者id存在就是跳转，不存在就是新增，不做任何处理
    if (e && e.id) {
      // 跳转页面
      this.$store.commit("updatePatient", e);
      this.$router.push("/main/manage/folder");
    }
  }
  private getLabel(item: any) {
    let str: any = "";
    if (item.name) {
      str += item.name;
    }
    if (item.gender && item.gender.id) {
      str += " " + item.gender.label;
    }
    if (item.age) {
      str += " " + item.age + "岁";
    }
    if (item.phone_number) {
      str += " " + item.phone_number;
    }
    return str;
  }
  private keyVal(val: any) {
    return GetKey(val);
  }
  private numberChange(type: any) {
    if (!this.patient[type]) {
      this.patient[type] = null;
    }
  }
  // 根据身份证号填充出生日期和性别
  private uidBlur() {
    // 认证方式为身份证才能填充
    if (!this.patient.uid_type || this.patient.uid_type.value != "身份证") {
      return;
    }
    // 需要身份证号存在，并且位数正确才能填充
    // 首先需要验证身份证位数是正确的
    let uId: any = this.patient.uid.toString();
    if (uId.length !== 18) {
      return;
    }
    // 填充性别,性别不存在才能填充
    if (!this.patient.gender || !this.patient.gender.id) {
      let sex: any = "";
      const num = Number(uId.substr(16, 1));
      if (num % 2 === 0) {
        sex = "女";
      } else {
        sex = "男";
      }
      this.genders.forEach((ele: any) => {
        if (ele.label == sex) {
          this.patient.gender = ele;
        }
      });
    }
    // 填充出生日期，出生日期不存在才能填充
    if (!this.patient.birthday) {
      const year: any = Number(uId.substr(6, 4));
      const month: any = Number(uId.substr(10, 2));
      const day: any = Number(uId.substr(12, 2));
      if (year < 1900 || year > 2200) {
        return;
      }
      if (month < 1 || month > 12) {
        return;
      }
      if (day < 1 || day > 31) {
        return;
      }
      if ([1, 3, 5, 7, 8, 10, 12].indexOf(month) == -1) {
        if (day > 30) {
          return;
        }
      }
      if (year % 4 !== 0 && month === 2 && day > 28) {
        return;
      }
      this.patient.birthday = "" + year + "-" + month + "-" + day;
      this.$forceUpdate();
    }
  }
  private remoteMethod(e: any) {
    const params: any = {
      params: {
        page: 1,
        search: e || "",
        limit: 100,
      },
    };
    GetPatientList(this, params).then((res: any) => {
      this.patientList = res.data;
    });
  }
  private save() {
    if (!this.patient.name) {
      this.$message.warning("请输入会员姓名");
      return;
    }
    if (!this.patient.gender) {
      this.$message.warning("请选择性别");
      return;
    }
    if (!this.patient.uid_type || !this.patient.uid_type.id) {
      this.$message.warning("请选择认证方式");
      return;
    }
    if (!this.patient.uid) {
      this.$message.warning("请输入认证号");
      return;
    }
    if (!this.patient.birthday) {
      this.$message.warning("请选择出生日期");
      return;
    }
    // if (!this.patient.phone_number) {
    //   this.$message.warning("请输入手机号");
    //   return;
    // }
    if (!this.patient.agree_informed_form) {
      this.$message.warning("请同意健康管理知情同意书");
      return;
    }
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    if (!this.patient.phone_number) {
      this.patient.phone_number = "";
    }
    if (this.patient.id) {
      PatchEditPatient(this, this.patient.id, this.patient, loading).then(
        (res: any) => {
          this.$message.warning("保存成功");
          this.$store.commit("updatePatient", res.data);
          this.getData();
        }
      );
    } else {
      PostAddPatient(this, this.patient, loading).then((res: any) => {
        this.$message.warning("保存成功");
        // this.$router.back();
        // 跳转会员管理页面,并选中创建的患者
        this.patient.id = res.data.id;
        this.getData().then((patient: any) => {
          this.$store.commit("updatePatient", patient);
          this.$router.push("/main/manage/folder");
        });
      });
    }
  }
  private openSelect(key: any, val: any) {
    this.selectTitle = key;
    if (val) {
      this.selectVal = JSON.parse(JSON.stringify(val));
    } else {
      this.selectVal = [];
    }
    this.ifShowSelect = true;
  }
  private selectChange(e: any) {
    const key = this.keyVal(this.selectTitle);
    this.patient[key] = e;
    this.$forceUpdate();
    this.ifShowSelect = false;
  }
  private goAgree() {
    this.showAgree = true;
  }
  private updateAgree(e: any) {
    this.showAgree = e;
  }
  private forceUpdate() {
    this.$forceUpdate();
  }
  private getType() {
    const params: any = {
      params: {
        dictionary_key: "认证号类型",
      },
    };
    GetDictionary(this, params).then((res: any) => {
      this.uidTypes = res.data;
    });
  }
  private getGenders() {
    const params: any = {
      params: {
        dictionary_key: "性别",
      },
    };
    GetDictionary(this, params).then((res: any) => {
      this.genders = res.data;
    });
  }
  private getSource() {
    GetAllSource(this, {}).then((res: any) => {
      this.sources = res.data;
    });
  }
  private getData() {
    return new Promise((resolve, reject) => {
      const loading = this.$loading({
        lock: true,
        text: "加载中……",
        spinner: "el-icon-loading",
        customClass: "loadClass",
        background: "rgba(255, 255, 255, 0.7)",
      });
      GetPatientDetail(this, this.patient.id, loading)
        .then((res: any) => {
          this.patient = res.data;
          resolve(res.data);
        })
        .catch(() => {
          reject();
        });
    });
  }
  /**
   * @description 加载三级联动数据，加载缓存的验证码等待时间
   */
  private beforeMount() {
    this.cityOption = cityData;
  }
  private mounted() {
    this.getType();
    this.getGenders();
    this.getSource();
    if (this.$route.query.id) {
      this.patient.id = this.$route.query.id;
      this.getData();
    }
  }
}
